// extracted by css-extract-rspack-plugin
export default {"wrapper":"_83cfa829"};